import {Component, Inject, Input, OnInit} from '@angular/core';
import {CheckoutPaymentBaseComponent} from "../checkout-payment-base/checkout-payment-base.component";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {TranslateService} from "@ngx-translate/core";
import {StoreOrderService} from "../../../../stores/store-order/store-order.service";
import {PaymentService} from "../../../payments/payment.service";
import {LocationService} from "../../../location.service";
import {WhitelabelService} from "../../../../shared/whitelabel.service";
import {WINDOW} from "../../../window-providers";
import {PaymentsenseService} from "../../../payments/paymentsense.service";
import {LocalStorageService} from "../../../../local-storage.service";
import {Event} from "../../../../stores/event";
import {ClientStore} from "../../../../stores/stores";

@Component({
  selector: 'app-checkout-payment-standalone',
  templateUrl: './checkout-payment-standalone.component.html',
  styleUrl: './checkout-payment-standalone.component.scss'
})
export class CheckoutPaymentStandaloneComponent extends CheckoutPaymentBaseComponent implements OnInit{

  @Input() selectedStore: ClientStore;

  constructor(protected route: ActivatedRoute,
              protected store: Store<any>,
              protected translate: TranslateService,
              protected storeOrderService: StoreOrderService,
              protected paymentService: PaymentService,
              protected locationService: LocationService,
              protected whitelabelService: WhitelabelService,
              @Inject(WINDOW) protected window: Window,
              protected paymentsenseService: PaymentsenseService,
              protected router: Router,
              protected storageService: LocalStorageService,
  ) {
    super(route, store, translate, storeOrderService, paymentService, locationService, whitelabelService, window, paymentsenseService, router, storageService);
  }

  onInitiatePaymentFailure(evt: Event) {
    this.window.location.href = this.window.location.origin + '/standalone-payment/standalone-payment-error';
  }



  redirectPaymentPay() {
    this.window.location.href = this.window.location.origin + '/standalone-payment/standalone-payment-pay';
  }

  redirectPhysicalPaymentProgress() {
    this.window.location.href = this.window.location.origin + '/standalone-payment/standalone-payment-progress';
  }

  getPaymentRoutingUrl() {
    return encodeURIComponent(this.window.location.origin + '/standalone-payment/standalone-payment-error')
  }

  getPaymentRoutingThankYouUrl() {
    return encodeURIComponent(this.window.location.origin + '/standalone-payment/standalone-payment-success');
  }

  onInitiateJccPayment() {
    this.setSpType(this.queryParams?.parameterName, this.queryParams?.parameterValue)
  }

  setSpType(parameterName, parameterValue) {
    if (parameterName === 'amount') {
      this.storageService.setSavedState(parameterValue, 'sp-amount');
      this.storageService.removeSavedState('standalone-location');
      this.storageService.removeSavedState('standalone-id');
      this.storageService.removeSavedState('standalone-order');
    } else if (parameterName === 'orderToken') {
      this.storageService.setSavedState(parameterValue, 'standalone-order');
      this.storageService.removeSavedState('standalone-location');
      this.storageService.removeSavedState('standalone-id');
      this.storageService.removeSavedState('sp-amount');
    } else if (parameterName === 'l') {
      this.storageService.setSavedState(parameterValue, 'standalone-location');
      this.storageService.removeSavedState('standalone-order');
      this.storageService.removeSavedState('sp-amount');
    }
  }

  getPaymentDetails() {
    return {};
  }

  ngOnInit(): void {
    super.onInit();
  }
}
